import authTokenSet from './authTokenSet';
import { axiosWi } from './axiosWi';
import { axiosInsight } from './axiosInsight';

const attachInterceptors = (client: any) => {
	client.interceptors.request.use((config: any) => {
		const token = localStorage.getItem('authToken');
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
			authTokenSet(token);
		} else {
			authTokenSet(false);
		}
		return config;
	});

	client.interceptors.response.use(
		(response: any) => response,
		(error: any) => {
			if (error.response?.status === 401) {
				localStorage.clear();
				authTokenSet(false);
				window.location.href = '/auth-pages/login';
			}
			return Promise.reject(error);
		},
	);
};

attachInterceptors(axiosWi);
attachInterceptors(axiosInsight);

export { axiosWi, axiosInsight };
